import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  getSpecificationFromState,
  getSpecificationSkillsFromState,
} from "features/competence.selectors";

import SpecificationItemList from "features/specification/components/SpecificationItemList";

class SpecificationSkillListContainer extends PureComponent {
  render() {
    const { specificationSkills } = this.props;

    if (!specificationSkills.size) {
      return null;
    }

    return (
      <SpecificationItemList items={specificationSkills} {...this.props} />
    );
  }
}

export default compose(
  connect(
    (state, { specificationId }) => ({
      specification: getSpecificationFromState(state, specificationId),
      specificationSkills: getSpecificationSkillsFromState(
        state,
        specificationId,
      ),
    }),
    null,
  ),
)(SpecificationSkillListContainer);
